
import React, { useState, useEffect } from "react";
import {
    TextField,
    Typography,
    Box,
    Grid,
    FormControlLabel,
    Switch,
    MenuItem,
    Button
} from '@mui/material';
import { useStudio } from '../../Context/StudioContext';
import { db } from "../../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { postGuestWishApi } from "../../api/cardApi";
import { formatTimeRange, format12Hour } from "../../utils/FormatTime";
import ThemeButton from "./ThemeButton";
import { getTranslations } from "../../utils/CardTranslations";



const WishForm = ({ data, onClose, source = 'firebase', uniqueCode, onWishPosted }) => {

    const [name, setName] = useState("");
    const [guestWish, setGuestWish] = useState("");
    const t = getTranslations(data?.language);




    const handleSubmit = async () => {
        if (!name || !guestWish) {
            alert(t.wishFormEmptyAlert);
            return;
        }

        if (data.status === 'PENDING PAYMENT' || data.status === 'DRAFT') {
            alert("Please complete the payment to enable this feature.");
            return;
        }

        try {
            if (source === 'api') {
                // New cards — REST API

                await postGuestWishApi(uniqueCode, {
                    senderName: name,
                    message: guestWish,
                });
                onWishPosted?.(); // re-fetch wishes so new wish appears instantly
            } else {
                // Old Firebase cards
                await addDoc(
                    collection(db, "guestWish", data.id, "wishes"),
                    {
                        name,
                        guestWish,
                        createdAt: serverTimestamp(),
                    }
                );
            }

            alert(t.wishFormSuccess);
            onClose?.();

        } catch (error) {
            console.error("Guest Wish Error:", error);
            alert(t.wishFormError);
        }
    };





    return (<div style={{ fontFamily: data.fontStyle, textAlign: 'start', width: "300px" }}>

        <Box sx={{ mt: 0, p: 2, border: '1px solid #ddd', borderRadius: '20px', backdropFilter: "blur(3px)", background: "rgba(255, 255, 255, 0.85)" }}>

            <TextField
                label={t.wishFormNameLabel}
                fullWidth
                size="small"
                margin="normal"
                onChange={(e) => setName(e.target.value)}
                InputLabelProps={{ shrink: true }}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "30px", // Change this value
                    },
                    '& .MuiInputBase-input': {

                        padding: "10px 14px"
                    }
                }}
            />

            <TextField
                label={t.wishFormWishLabel}
                fullWidth
                multiline
                minRows={2}
                size="small"
                margin="normal"
                onChange={(e) => setGuestWish(e.target.value)}
                InputLabelProps={{ shrink: true }}

                sx={{
                    "& .MuiOutlinedInput-root": {
                        borderRadius: "15px", // Change this value
                    },
                    '& .MuiInputBase-input': {

                        gap: 0
                    }
                }}
            />

            <Box sx={{ display: 'grid', gap: 1, mt: 5 }}>
                <ThemeButton themeColor={data.themeColour} onClick={handleSubmit}>{t.wishFormSubmit}</ThemeButton>

            </Box>

        </Box>
    </div >
    )
};

export default WishForm;
